export default class UserPersistence {

  static instance;

  static getInstance() {
    if (UserPersistence.instance == null) {
      UserPersistence.instance = new UserPersistence();
    }
    return UserPersistence.instance;
  }

  constructor(){
    this._userId = null;
    this._userType = null;
    this._userImage = null;
    this._userName = null;
    this._userClass = null;
    this._userAccessToken = null;
    this._accountCreateTime = null;
    this._vehicleInfo = null;
  }

  
  get userId() {
    //console.log('get')
    return this._userId;
  }
  set userId(userId) {
    //console.log('set')
    this._userId = userId;
  }

  get userType() {
    //console.log('get')
    return this._userType;
  }
  set userType(userType) {
    //console.log('set')
    this._userType = userType;
  }

  get userImage() {
    //console.log('get')
    return this._userImage;
  }

  
  set userImage(userImage) {
    //console.log('set')
    this._userImage = userImage;
  }

  get userName() {
    //console.log('get')
    return this._userName;
  }
  set userName(userName) {
    //console.log('set')
    this._userName = userName;
  }

  get userClass() {
    //console.log('get')
    return this._userClass;
  }
  set userClass(userClass) {
    //console.log('set')
    this._userClass = userClass;
  }


  get userAccessToken() {
    //console.log('get')
    return this._userAccessToken;
  }
  set userAccessToken(userAccessToken) {
    //console.log('set')
    this._userAccessToken = userAccessToken;
  }

  get accountCreateTime() {
    //console.log('get')
    return this._accountCreateTime;
  }
  set accountCreateTime(accountCreateTime) {
    //console.log('set')
    this._accountCreateTime = accountCreateTime;
  }

  get vehicelInfo(){
    return this._vehicleInfo;
  }
  
  set vehicelInfo(vehicelInfo){
    console.log('set')
    this._vehicleInfo = vehicelInfo;
  }
}
